export const listData = new WeakMap();
function normalizeKey(key) {
    if (typeof key === 'string') {
        return key.replace(/\s*/g, '');
    }
    return `${key}`;
}
export function getItemId(state, itemKey) {
    const data = listData.get(state);
    if (!data) {
        throw new Error('Unknown list');
    }
    return `${data.id}-option-${normalizeKey(itemKey)}`;
}

//# sourceMappingURL=utils.js.map